import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import T from 'i18n-react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { ItemGrid } from 'components';
import { Input, PasswordWithStrongField } from 'components/Form';
import { Formik } from 'formik';
import * as Yup from 'yup';
import get from 'lodash/get';
// eslint-disable-next-line import/extensions
import loginStyles from 'assets/jss/icw/loginStyle.jsx';
import { LOGIN_LANG_PATH } from 'shared/path';
import { setLanguageLocale } from 'util/icwUtility';
import { LOGIN_PATH } from 'shared/routes';
import icwLogo from 'assets/img/qmas_logo_login.png';

setLanguageLocale(T, [LOGIN_LANG_PATH]);

const ChangePassword = (props) => {
  const { onInit, classes, status, match, onChangePassword } = props;
  const [, setPasswordStrong] = useState([]);
  // const [confirmPasswordField, setConfirmPasswordField] = useState('');
  const [token, setToken] = useState('');
  const formEl = useRef(null);

  const yupValidate = Yup.object().shape({
    password: Yup.string(),
    confirmedPassword: Yup.string()
      .oneOf(
        [Yup.ref('password'), null],
        T.translate('login.userUpdatePassword.confirmPasswordDontMatch')
      )
      .required(T.translate('login.userUpdatePassword.confirmPasswordRequired')),
  });

  const initialValues = {
    password: '',
    confirmedPassword: '',
  };

  const onSubmit = (values) => {
    onChangePassword(token, values.password, values.confirmedPassword);
  };
  useEffect(() => {
    setToken(get(match, 'params.token', ''));
    onInit(get(match, 'params.token', ''));

    // eslint-disable-next-line
  }, []);

  const renderForm = (formProps) => {
    const {
      handleSubmit,
      values,
      isValid,
      dirty,
      errors,
      setFieldValue,
      touched,
      setFieldTouched,
    } = formProps;

    return (
      <form className={classes.form} onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} spacing={2} align='center'>
            <a href='/'>
              <img className={classes.icon} src={icwLogo} alt='logo' />
            </a>
          </Grid>
          <Grid item xs={12} sm={12} md={12} align='center'>
            <h3 className={classes.title}>{T.translate('login.resetPassword')}</h3>
          </Grid>

          <Grid item xs={12} sm={12} md={12} align='center' className={classes.password}>
            <Grid item xs={12} sm={12} md={6} align='center'>
              <PasswordWithStrongField
                passwordProps={{
                  formProps,
                  className: classes.textField,
                  onPasswordStrong: (val) => {
                    setPasswordStrong(val);
                  },
                  onChange: (e) => {
                    if (!e.target.value) {
                      setFieldValue('confirmedPassword', '');
                      setFieldTouched('confirmedPassword', false);
                    }
                  },
                }}
              />
              <Input
                type='text'
                inputProps={{
                  label: T.translate('login.userUpdatePassword.confirmNewPassword'),
                  name: 'confirmedPassword',
                  formProps,
                  className: classes.textField,
                  type: 'password',
                  placeholder: T.translate('login.userUpdatePassword.confirmNewPassword'),
                  errorText:
                    !!values.password && touched.confirmedPassword && errors.confirmedPassword,
                  isEyeVisibilityIcon: true,
                }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} align='center'>
            <Grid item xs={12} sm={12} md={6} align='center'>
              <Button
                color='primary'
                className={classes.button}
                autoFocus
                type='submit'
                disabled={!dirty || !isValid}
                fullWidth='true'>
                {T.translate('login.resetPassword')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    );
  };

  if (status === 'invalid-token') {
    return (
      <div className={classes.login}>
        <Grid container align='center' direction='column' spacing={0} className={classes.container}>
          <ItemGrid xs={12}>
            <a href='/'>
              <img className={classes.icon} src={icwLogo} alt='logo' />
            </a>
          </ItemGrid>
          <ItemGrid xs={12} className={classes.grid}>
            <div className={classes.loginContainer}>
              <div className={classes.expiredMessage}>{T.translate('login.expiredMessage')}</div>
              <div className={classes.receiveCode}>
                <Link className={classes.link} to={`/${match.params.locale}/reset-password`}>
                  {T.translate('login.forgotPassword')}
                </Link>
              </div>
            </div>
          </ItemGrid>
        </Grid>
      </div>
    );
  }
  if (status === 'success') {
    return (
      <div className={classes.login}>
        <Grid container align='center' direction='column' spacing={0} className={classes.container}>
          <ItemGrid xs={12}>
            <a href='/'>
              <img className={classes.icon} src={icwLogo} alt='logo' />
            </a>
          </ItemGrid>
          <ItemGrid xs={12} className={classes.grid}>
            <div className={classes.loginContainer}>
              <div className={classes.expiredMessage}>
                {T.translate('login.updatePasswordSuccess')}
              </div>
              <div className={classes.receiveCode}>
                <Link className={classes.link} to={`/${match.params.locale}${LOGIN_PATH}`}>
                  {T.translate('general.login')}
                </Link>
              </div>
            </div>
          </ItemGrid>
        </Grid>
      </div>
    );
  }
  return (
    <div className={classes.wrapper}>
      <Formik
        initialValues={initialValues}
        validationSchema={yupValidate}
        enableReinitialize
        onSubmit={(values) => {
          onSubmit(values);
        }}
        innerRef={formEl}>
        {(fmProps) => renderForm(fmProps)}
      </Formik>
    </div>
  );
};

ChangePassword.defaultProps = {
  status: '',
};

ChangePassword.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  onChangePassword: PropTypes.func.isRequired,
  onInit: PropTypes.func.isRequired,
  status: PropTypes.string,
};

export default withStyles(loginStyles)(ChangePassword);
